import * as React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

export interface RouterNavLinkProps extends NavLinkProps {
  icon?: React.ImgHTMLAttributes<HTMLImageElement>;
}

// export class RouterNavLink extends React.PureComponent<RouterNavLinkProps> {
export class RouterNavLink extends React.Component<RouterNavLinkProps> {
  public render(): React.ReactNode {
    const {
      href,
      to,
      replace,
      innerRef,
      activeClassName,
      activeStyle,
      exact,
      strict,
      isActive,
      location,
      children,
      icon,
      ...anchorPros
    } = this.props;

    const { alt, ...iconProps } = icon || ({} as React.ImgHTMLAttributes<HTMLImageElement>);
    const trimmedAlt = (alt || '').trim();
    if (trimmedAlt.length === 0) {
      iconProps.role = 'presentation';
    }

    if (href != null) {
      return (
        <a href={href} {...anchorPros}>
          {iconProps != null && Object.prototype.hasOwnProperty.call(iconProps, 'src') && <img alt={trimmedAlt} {...iconProps} />}
          {children}
        </a>
      );
    }

    return (
      <NavLink
        to={to}
        replace={replace}
        innerRef={innerRef}
        activeClassName={activeClassName}
        activeStyle={activeStyle}
        exact={exact}
        strict={strict}
        isActive={isActive}
        location={location}
        {...anchorPros}
      >
        {iconProps != null && Object.prototype.hasOwnProperty.call(iconProps, 'src') && <img alt={trimmedAlt} {...iconProps} />}
        {children}
      </NavLink>
    );
  }
}
